function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;



//////////////////
// WEBPACK FOOTER
// ./~/styled-components/~/@emotion/memoize/dist/memoize.browser.esm.js
// module id = OkTJ
// module chunks = 0